import { PricingQuotaConfiguration } from "./pricing-quota-configuration.model";

export class Pricing {
  private pricingKey: string;
  private maxPrice: number;
  private price: number;
  private pricingQuotaConfiguration: PricingQuotaConfiguration;
  private created: string;
  private modified: string;

  public getPricingKey(): string {
    return this.pricingKey;
  }

  public setPricingKey(pricingKey: string): void {
    this.pricingKey = pricingKey;
  }

  public getMaxPrice(): number {
    return this.maxPrice;
  }

  public setMaxPrice(maxPrice: number): void {
    this.maxPrice = maxPrice;
  }

  public getPrice(): number {
    return this.price;
  }

  public setPrice(price: number): void {
    this.price = price;
  }

  public getPricingQuotaConfiguration(): PricingQuotaConfiguration {
    return this.pricingQuotaConfiguration;
  }

  public setPricingQuotaConfiguration(pricingQuotaConfiguration: PricingQuotaConfiguration): void {
    this.pricingQuotaConfiguration = pricingQuotaConfiguration;
  }

  public getCreated(): string {
    return this.created;
  }

  public setCreated(created: string): void {
    this.created = created;
  }

  public getModified(): string {
    return this.modified;
  }

  public setModified(modified: string): void {
    this.modified = modified;
  }
}
